import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosClient, formatError, getBaseUrlVersioned } from "../../../services/axiosClient";
import conversationLogger from "../conversationLogger";
const API_VERSION_CLONE = "v1";
const API_PATH_CLONE = "conversations/clone";
export const cloneConversation = createAsyncThunk("conversation/clone", async (param) => {
    try {
        const apiUrl = `${getBaseUrlVersioned(API_VERSION_CLONE)}/${API_PATH_CLONE}`;
        const response = await axiosClient.post(apiUrl, param);
        return response.data;
    }
    catch (error) {
        conversationLogger.error(`Error cloning conversation with param '${JSON.stringify(param)}'\nreceived: ${formatError(error)}`);
        throw error;
    }
});
const initialState = {
    character_id: "",
    id: "",
    isLoading: false,
    error: null,
};
const cloneConversationSlice = createSlice({
    name: "cloneConversation",
    initialState: initialState,
    reducers: {
        resetCloneConversationState: (state) => {
            state.isLoading = false;
            state.id = "";
            state.character_id = "";
            state.error = null;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(cloneConversation.pending, (state) => {
            state.isLoading = true;
        })
            .addCase(cloneConversation.fulfilled, (state, action) => {
            state.isLoading = false;
            state.id = action.payload.id;
            state.character_id = action.payload.character_id;
            state.error = null;
        })
            .addCase(cloneConversation.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.error;
            state.id = "";
            state.character_id = "";
        });
    },
});
export default cloneConversationSlice.reducer;
export const { resetCloneConversationState } = cloneConversationSlice.actions;
